import React from 'react';

const HomePageIcon = ({
  width = '16',
  height = '16',
  fill = '#EF4821',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <rect x="1" y="1" width="6.5" height="6.5" rx="1.5" fill={fill} />
    <rect x="8.5" y="1" width="6.5" height="6.5" rx="1.5" fill={fill} />
    <rect x="8.5" y="8.5" width="6.5" height="6.5" rx="1.5" fill={fill} />
    <rect x="1" y="8.5" width="6.5" height="6.5" rx="1.5" fill={fill} />
  </svg>
);

export default HomePageIcon;
